






















































































import { Component, Vue } from 'vue-property-decorator';
import Agency from "@/store/entities/agency";
import Balance from "@/store/entities/finance/balance";
@Component({})
export default class LoadBalance extends Vue {
  dialog: boolean = true;
  agencies: Agency[] = [];
  agency:Agency=new Agency();
  creditLimit:number=0;
  balance:Balance= new Balance()

  created() {
    console.log(this.agency.id)
    this.getAgency();
  }

    async getAgency() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });
    this.agencies = this.$store.state.agency.list;
  }

    async addBalance() {
      this.balance.agencyId=this.agency.id;
      this.balance.creditLimit=this.creditLimit;
      await this.$store.dispatch({
        type: "agency/addAgencyLimit",
        data: this.balance,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
  }




  data() {
    return {};
  }

  closeDialog() {
    this.$emit('closed');
  }
}
